<script setup>
import SelectionButtonsInput from "@/components/forms/SelectionButtonsInput.vue";
import SelectionButton from "@/components/forms/SelectionButton.vue";
import {UnitType, UnitTypeLabel} from "@/choices";
import {watch} from "vue";

const unitType = defineModel('unitType', {type: Number});
const unitTypeSpec = defineModel('unitTypeSpec', {type: String});
const callSign = defineModel('callSign', {type: String});
const props = defineProps({
    unitTypeProps: {
        type: Object,
    },
    unitTypeSpecProps: {
        type: Object,
    },
    callSignProps: {
        type: Object,
    },
    validateField: {
        type: Function,
        required: true,
    }
});
const emit = defineEmits(['submit']);

watch(unitType, (newType, previousType) => {
    newType = parseInt(newType);
    previousType = parseInt(previousType);
    const prefix = 'ZPM ';
    const emsVehicles = [UnitType.RV, UnitType.RZP, UnitType.RLP];
    if (emsVehicles.includes(newType)) {
        if (!emsVehicles.includes(previousType)) {
            if (!callSign.value || !callSign.value.startsWith(prefix)) {
                callSign.value = prefix;
            }
        }
    } else {
        if (emsVehicles.includes(previousType)) {
            if (callSign.value !== null && callSign.value.startsWith(prefix)) {
                callSign.value = '';
            }
        }
    }
});

async function submit() {
    const {valid: unitTypeValid} = await props.validateField('unitType');
    const {valid: unitTypeSpecValid} = await props.validateField('unitTypeSpec');
    const {valid: callSignValid} = await props.validateField('callSign');
    if (!unitTypeValid || !unitTypeSpecValid || !callSignValid) {
        return;
    }

    emit('submit', {
        unitType: unitType.value,
        unitTypeSpec: unitTypeSpec.value,
        callSign: callSign.value,
    });
}
</script>

<template>
    <main>
        <h1>{{ pgettext('title', 'Transport Unit') }}</h1>

        <SelectionButtonsInput v-model="unitType" v-bind="unitTypeProps" size="x-large" :height="72">
            <SelectionButton v-for="[value, label] of Object.entries(UnitTypeLabel)"
                             :key="value"
                             :value="Number(value)">
                <strong>{{ label }}</strong>
            </SelectionButton>
        </SelectionButtonsInput>

        <v-text-field v-model="unitTypeSpec"
                      v-bind="unitTypeSpecProps"
                      v-if="parseInt(unitType) === UnitType.OTHER"
                      :required="true"
                      :label="pgettext('label', 'Unit Type')"
                      class="transport-wizard__text-input"/>

        <v-text-field v-if="unitType"
                      v-model="callSign"
                      v-bind="callSignProps"
                      :required="true"
                      :label="pgettext('label', 'Call sing / LP')"
                      class="transport-wizard__text-input"/>

        <p class="text-center mt-4" v-if="unitType">
            <v-btn color="green" size="large" @click="submit()">
                <strong>{{ pgettext('action', 'Continue') }}</strong>
            </v-btn>
        </p>

        <p v-else class="text-center text-subtitle-2">
            {{ gettext('To continue, please select one of the options.') }}
        </p>
    </main>
</template>
